module.exports = __webpack_public_path__ + "static/media/cross.6a91493d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/game/bomber/bomb/cross.svg
// module id = 29
// module chunks = 0